import {ReviewService, FormService} from '../services'
import {bindLoading} from './index';
import {RoleTypes} from '../constants';

export default {
    namespaced: true,
    state: {
        forms:[],
        role:{
            id: '',
            type: RoleTypes.None
        }
    },
    getters:{
        isOfficer(state) {
            return state.role.type === RoleTypes.Officer;
        }
    },
    mutations: {
        saveWaitingForms(current, forms) {
            current.forms.splice(0);
            current.forms = forms;
        },
        saveCurrentRole(current, role) {
            current.role = {...role};
        }
    },
    actions: {
        async getWaitingFormsAction({dispatch, commit}) {
            await bindLoading(commit, async () => commit('saveWaitingForms', await ReviewService.getWaitingForm()), 'review')
        },
        async getCurrentRoleAction({dispatch, commit}){
            await bindLoading(commit, async () => commit('saveCurrentRole', await ReviewService.getCurrentRole()), 'review')
        },
        async signAction({dispatch, commit, state}, todo){
            return await bindLoading(commit, async () => {
                const {success, messages, instance} = await FormService.sign(todo);
                if(success){
                    const newForms = state.forms.filter(h => h.id !== instance);
                    commit('saveWaitingForms', newForms);
                }
                return {success, messages};
            }, 'review')
        },

        async signAllAction({dispatch, commit, state}, ids){
            return await bindLoading(commit, async () => {
                const {success, messages, instance} = await FormService.signAll(ids);
                if(success){
                    const newForms = state.forms.filter(h => !instance.some(i => h.id === i));
                    commit('saveWaitingForms', newForms);
                }
                return {success, messages};
            }, 'review')
        },
        async denyAction({dispatch, commit, state}, todo){
            return await bindLoading(commit, async () => {
                const {success, messages, instance} = await FormService.deny(todo);
                if(success){
                    const newForms = state.forms.filter(h => h.id !== instance);
                    commit('saveWaitingForms', newForms);
                }
                return {success, messages};
            }, 'review')
        }
    }
}